import { appActions } from "../slices/app-slice";
import http from "../api/http";
import axios from "axios";
// import config from '../../config';

export const setDownloading = (boolIsLoading = false) => {
  return (dispatch) => {
    dispatch(appActions.setDownloading(boolIsLoading));
  };
};

export const setLoading = (boolIsLoading = false) => {
  return (dispatch) => {
    dispatch(appActions.setLoading(boolIsLoading));
  };
};

export const setAppLoading = (loading = false, delay = 0) => {
  return (dispatch) => {
    // Set a timeout to set loading to false after the specified delay
    setTimeout(() => {
      dispatch(appActions.setAppLoading(loading));
    }, delay);
  };
};

export const setGlobalSyncInProgress = (boolIsLoading = false) => {
  return (dispatch) => {
    dispatch(appActions.setGlobalSyncedInProgress(boolIsLoading));
  };
};

export const setFilterDates = (dates, scope) => {
  return (dispatch) => {
    dispatch(appActions.setFilterDates({ dates, scope }));
  };
};

export const setDrawerFilterActive = (boolIsLoading = false, scope) => {
  return (dispatch) => {
    dispatch(appActions.setDrawerFilterActive({ boolIsLoading, scope }));
  };
};

export const openDrawerFilter = (
  boolIsLoading = false,
  header,
  content,
  size
) => {
  return (dispatch) => {
    dispatch(
      appActions.openDrawerFilter({ boolIsLoading, header, content, size })
    );
  };
};

export const clearDrawerFilter = () => {
  return (dispatch) => {
    dispatch(appActions.clearDrawerFilter());
  };
};

export const setAppNotification = (
  notificationMessage,
  notificationSeverity
) => {
  return (dispatch) => {
    dispatch(
      appActions.setNotification({ notificationMessage, notificationSeverity })
    );
  };
};

export const resetAppNotification = (isMobile) => {
  return (dispatch) => {
    dispatch(appActions.resetNotification());
  };
};

export const setGlobalAppNotification = (strMessage = "", type = "info") => {
  return (dispatch) => {
    dispatch(appActions.setGlobalNotification({ message: strMessage, type }));
  };
};

export const removeGLobalAppNotification = (index = 0) => {
  return (dispatch) => {
    dispatch(appActions.removeGlobalNotification(index));
  };
};

export const clearGLobalAppNotification = () => {
  return (dispatch) => {
    dispatch(appActions.clearGlobalNotification());
  };
};

export const uploadFile = (
  options,
  callback,
  callbackError,
  lead,
  deal,
  fileUsage
) => {
  const { onSuccess, onError, file } = options;
  const apiBaseUrl = process.env.REACT_APP_UPLOAD_FILE_SINGLE;
  const formData = new FormData();

  formData.append("file", file);
  formData.append("isPublic", false);
  formData.append("purpose", fileUsage);

  if (lead) {
    formData.append("lead", lead);
  }

  if (deal) {
    formData.append("deal", deal);
  }

  http.interceptors.request.use((config) => {
    config.headers = { "Content-Type": "multipart/form-data" };
    return config;
  });

  // const config = { headers: { 'Content-Type': 'multipart/form-data' } };

  const request = http.post(apiBaseUrl, formData);

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data);
        }
        dispatch(setLoading(false));
        if (onSuccess) onSuccess("Ok");
        dispatch(setLoading(true));
      },
      (error) => {
        if (callbackError) {
          callbackError();
        }
        if (onError) onError({ error });
        dispatch(setLoading(false));
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Upload Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
      }
    );
  };
};

export const replaceFile = (
  options,
  fileToReplace,
  callback,
  callbackError
) => {
  // (objUploadFile, fileToReplace, callback)
  const apiBaseUrl = process.env.REACT_APP_UPLOAD_REPLACE;
  const formData = new FormData();
  const { onSuccess, onError, file } = options;
  console.log("objUploadFile", file);

  formData.append("file", file);
  formData.append("isPublic", false);
  formData.append("fileToReplace", fileToReplace);

  // http.interceptors.request.use((config) => {
  //     config.headers = { 'Content-Type': 'multipart/form-data' };
  //     return config;
  // });

  const config = { headers: { "Content-Type": "multipart/form-data" } };

  const request = http.post(apiBaseUrl, formData, config);

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data);
        }
        dispatch(setLoading(false));
        if (onSuccess) onSuccess("Ok");
        dispatch(setLoading(true));
      },
      (error) => {
        if (onError) onError({ error });
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Upload Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
        dispatch(setLoading(false));
      }
    );
  };
};

export const downloadFile = (fileName = "", callback) => {
  const apiBaseUrl = process.env.REACT_APP_DOWNLOAD_FILE + "/" + fileName;

  const request = http.get(apiBaseUrl, { responseType: "blob" });

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        // dispatch(setLoading(false))
        if (callback) {
          let arrFilename = fileName.split(".");
          let strExt = arrFilename.pop();
          callback(data, fileName, strExt);
        }
        dispatch(setLoading(false));
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
        dispatch(setLoading(false));
      }
    );
  };
};

export const downloadBlobFile = (fileName = "", callback) => {
  const apiBaseUrl = process.env.REACT_APP_DOWNLOAD_FILE + "/" + fileName;

  const request = http.get(apiBaseUrl, { responseType: "blob" });

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        // dispatch(setLoading(false))
        if (callback) {
          let arrFilename = fileName.split(".");
          let strExt = arrFilename.pop();
          callback(data, fileName, strExt);
        }
        dispatch(setLoading(false));
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
        dispatch(setLoading(false));
      }
    );
  };
};

export const downloadCalculatorPDF = (
  objData = {},
  type = "mortgage",
  callback
) => {
  let data = JSON.stringify(objData);

  let url =
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_DEV_URL}/api/download/${type}`
      : `${process.env.REACT_APP_PDF_API_URL}/download/${type}`;

  const request = axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
  });

  return (dispatch) => {
    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data);
        }
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
      }
    );
  };
};

export const downloadProposalPDF = (objData = {}, callback) => {
  let type = "proposal";
  let data = JSON.stringify(objData);

  let url =
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_DEV_URL}/api/download/${type}`
      : `${process.env.REACT_APP_PDF_API_URL}/download/${type}`;

  const request = axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
  });

  return (dispatch) => {
    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data);
        }
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
      }
    );
  };
};

export const downloadZipFile = (objParams, callback) => {
  const apiBaseUrl = process.env.REACT_APP_DOWNLOAD_FILE + "/download-zip";

  const request = http.post(apiBaseUrl, objParams, {
    responseType: "blob",
  });

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data, objParams.filename);
        }
        dispatch(setLoading(false));
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
        dispatch(setLoading(false));
      }
    );
  };
};

export const deleteFile = (fileId, callback) => {
  const { REACT_APP_DOWNLOAD_FILE } = process.env;
  const res = http.delete(`${REACT_APP_DOWNLOAD_FILE}/${fileId}`);
  return (dispatch) => {
    dispatch(setLoading(true));
    res
      .then(({ data }) => {
        if (typeof callback === "function") {
          callback();
        }
        dispatch(setGlobalAppNotification("File Deleted.", "success"));
      })
      .catch((error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.message ||
              error?.messages ||
              "Error Deleting Role!",
            "error"
          )
        );
        dispatch(setLoading(false));
      });
  };
};

export const downloadInvalidBankProducts = (objParams, callback) => {
  const apiBaseUrl = `${process.env.REACT_APP_API_URL}/api/v1/proposal/bankproducts/export/invalidrecords`;

  const request = http.post(apiBaseUrl, objParams, {
    responseType: "blob",
  });

  return (dispatch) => {
    dispatch(setLoading(true));

    return request.then(
      ({ data }) => {
        if (callback) {
          callback(data, objParams.fileName);
        }
        dispatch(setLoading(false));
      },
      (error) => {
        dispatch(
          setGlobalAppNotification(
            error?.response?.data?.errors?.message ||
              error?.messages ||
              "Download File Failed!",
            "error"
          )
        );
        // dispatch(setError(error?.response?.data?.errors?.message || 'Something went wrong'))
        dispatch(setLoading(false));
      }
    );
  };
};
